import { AccordionForm } from 'ui/molecules/accordion-form/AccordionForm';
import { SelectInput, useTranslate } from 'react-admin';
import { TextArea } from 'ui/atoms/textarea/TextArea';
import { ImageInput } from 'components/image-input/ImageInput';
import { Fieldset } from 'ui/molecules/fieldset/Fieldset';

import { DPE_DATA } from 'constants/real-estates';

import { EditFormContentProps } from '../editFormContent.types';
import { sourceToLabelMap } from '../EditFormContent.utils';

export const BeforeRenovationForm: React.FC<EditFormContentProps> = ({
  defaultExpanded,
  disabled = false,
}) => {
  const translate = useTranslate();

  return (
    <AccordionForm
      defaultExpanded={defaultExpanded}
      title={translate('realization.form.beforeRenovation')}
    >
      <TextArea
        margin="none"
        minRows={1}
        maxRows={10}
        label={sourceToLabelMap.get('beforeRenovation.description')}
        fullWidth
        source="beforeRenovation.description"
        variant="outlined"
        disabled={disabled}
      />
      <SelectInput
        disabled={disabled}
        margin="none"
        variant="outlined"
        choices={DPE_DATA}
        translateChoice={false}
        source="beforeRenovation.dpe"
        label={sourceToLabelMap.get('beforeRenovation.dpe')}
      />
      <Fieldset title="image" />

      <ImageInput
        disabled={disabled}
        source="beforeRenovation.images"
        isForRealization={true}
      />
    </AccordionForm>
  );
};
